import { createRouter, createWebHistory } from 'vue-router'
import FutureStar2026 from '../components/futurestar2026.vue'
import CollectView from '../components/collect.vue'

const routes = [
  {
    path: '/futurestar2026',
    name: 'FutureStar2026',
    component: FutureStar2026
  },
  {
    path: '/collect',
    name: 'CollectView',
    component: CollectView
  },
  {
    path: '/',
    redirect: '/futurestar2026' // 默认重定向到 futurestar2026
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router